// extracted by mini-css-extract-plugin
export default {"container":"style_container__joffi","titleSection":"style_titleSection__6QOqL"};